import { useEffect, useRef, useState } from "react";
import { getInstantWinPrizes } from "../../../dreamCar-service";
import InfiniteScroll from "react-infinite-scroll-component";
import { InstantWinPrize, InstantWinPrizesData } from "../types";
import { CARS_PER_PAGE } from "../../ourCars/ourCars-constants";
import InstantWinPrizeTile from "./instantWinPrizeTile";

const OurInstantWinPrizes = ({
  showTabbedVersion,
  competitionId,
}: {
  showTabbedVersion: boolean;
  competitionId: number;
}) => {
  const prizesStartIndex = useRef(0);
  const prizesEndIndex = useRef(CARS_PER_PAGE);
  const [instanWinPrizes, setInstantWinPrizes] = useState<InstantWinPrize[]>([]);
  const [instantWinPrizesInView, setInstantWinPrizesInView] = useState<InstantWinPrize[]>([]);

  useEffect(() => {
    (async () => {
      const response = await getInstantWinPrizes(competitionId);
      const { prizes } = (await response.json()) as InstantWinPrizesData;
      setInstantWinPrizes(prizes);
    })();
  }, []);

  useEffect(() => {
    setInstantWinPrizesInView([...instanWinPrizes.slice(prizesStartIndex.current, prizesEndIndex.current)]);
  }, [instanWinPrizes]);

  const fetchMorePrizes = () => {
    prizesStartIndex.current = prizesStartIndex.current + CARS_PER_PAGE;
    prizesEndIndex.current = prizesEndIndex.current + CARS_PER_PAGE;
    setInstantWinPrizesInView(loadedPrizes => [
      ...loadedPrizes,
      ...instanWinPrizes.slice(prizesStartIndex.current, prizesEndIndex.current),
    ]);
  };

  return (
    <InfiniteScroll
      dataLength={instantWinPrizesInView.length}
      next={fetchMorePrizes}
      hasMore={instantWinPrizesInView.length < instanWinPrizes.length}
      loader=""
      style={{ overflow: "hidden", background: "#f1f1f1" }}>
      <div className="grid xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 my-4 xs:px-1 xs:gap-2 md:px-4 md:gap-4">
        {instantWinPrizesInView.map((prize: InstantWinPrize, index: number) => (
          <div className="relative" key={`${prize.contentNodeId}-${index}`}>
            <InstantWinPrizeTile showTabbedVersion={showTabbedVersion} prize={prize} competitionId={competitionId} />
          </div>
        ))}
      </div>
    </InfiniteScroll>
  );
};

export default OurInstantWinPrizes;
